import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { posthog } from 'posthog-js';

export const useCookieConsent = createGlobalState(() => {
    const showBanner = ref(
        posthog.__loaded && !posthog.has_opted_in_capturing() && !posthog.has_opted_out_capturing(),
    );

    function acceptCookies() {
        posthog.opt_in_capturing();
        showBanner.value = false;
    }

    function declineCookies() {
        posthog.opt_out_capturing();
        showBanner.value = false;
    }

    return { showBanner, acceptCookies, declineCookies };
});
